import React, { useEffect, useState } from "react";

import { useGetCompanyUsers } from "../../hooks/useCrm";
import { DataPicker } from "../DataPicker/DataPicker";
import { formatDate } from "../../utils/formatDate";
import Button from "../Button/Button";
import { InputField1 } from "../InputField1/InputField1";
import { SimpleSelect1 } from "../SimpleSelect/SimpleSelect1";
import { ShamsiToMiladi } from "../../utils/Miladi_To_Shamsi";
import RollCallTable from "../RollCallTable/RollCallTable";
import { useSetRollCall } from "../../hooks/useManagement";
import { getTime } from "../../utils/getTime";
const initValue = {
  person_id: "",
  date: "",
  leave: "0",
  type: "",
};
const RollCallAdmin = () => {
  const { data, isLoading, refetch } = useGetCompanyUsers();
  const [form, setForm] = useState(initValue);
  const [dateRollType, setDateRollType] = useState("امروز(اکنون)");
  const [rollOutType, setRollOutType] = useState("بدون مرخصی");
  const { mutateAsync: setRollCall, isLoading: settingRollCall } =
    useSetRollCall();

  const handleSetRollCall = async (data) => {
    await setRollCall(data);
  };
  const [date, setDate] = useState();
  const [time, setTime] = useState();
  const users = data?.data?.ManagersAndColleagues;
  const usersOptions = users?.map((user) => {
    return {
      value: user.IdUser,
      label:
        (user.FirstName ? user.FirstName : "") +
        " " +
        (user.LastName ? user.LastName : ""),
    };
  });
  useEffect(() => {
    const generate = date + " " + time;
    const generated = generate.replace(/\//g, "-");

    setForm({ ...form, date: generated });
  }, [date, time]);
  const typeRoll = [
    { value: "0", label: "ورود" },
    { value: "1", label: "خروج" },
  ];
  const typeRollOut = [
    { value: "بدون مرخصی", label: "بدون مرخصی" },
    { value: "مرخصی ساعتی", label: "مرخصی ساعتی" },
    { value: "مرخصی روزانه", label: "مرخصی روزانه" },
  ];
  const dateType = [
    { value: "امروز(اکنون)", label: "امروز(اکنون)" },
    {
      value: "دستی",
      label: "دستی",
    },
  ];
  return (
    <>
      <div className="inputs row m-0 mt-3">
        <div className="col-lg-3 col-12">
          <SimpleSelect1
            label="لیست کاربران"
            res={usersOptions}
            onChange={(e) => setForm({ ...form, person_id: e.value })}
          />
        </div>
        <div className="col-lg-3 col-12">
          <SimpleSelect1
            res={dateType}
            label="تاریخ"
            onChange={(e) => {
              setDateRollType(e.value);
              if (e.value === "امروز(اکنون)") {
                setForm({ ...form, date: getTime() });
              }
            }}
          />
        </div>
        {dateRollType === "امروز(اکنون)" ? null : (
          <>
            <div className="col-lg-3 col-12">
              <DataPicker
                label="تاریخ دستی"
                local="fa"
                onChange={(e) => {
                  if (e) {
                    setDate(ShamsiToMiladi(formatDate(e)));
                  }
                }}
              />
            </div>
            <div className="col-lg-3 col-12">
              <InputField1
                type="time"
                label="ساعت دستی"
                onChange={(e) => setTime(e.target.value + ":00")}
              />
            </div>
          </>
        )}
        <div className="col-lg-3 col-12">
          <SimpleSelect1
            label="انتخاب فعالیت"
            res={typeRoll}
            onChange={(e) => setForm({ ...form, type: e.value })}
          />
        </div>
        <div className="col-lg-3 col-12">
          <SimpleSelect1
            label="انتخاب نوع مرخصی"
            res={typeRollOut}
            onChange={(e) => {
              setRollOutType(e.value);
              if (e.value === "مرخصی روزانه") {
                setForm({ ...form, leave: "9" });
              } else {
                setForm({ ...form, leave: "0" });
              }
            }}
          />
        </div>
        {rollOutType === "بدون مرخصی" ? null : rollOutType === "مرخصی ساعتی" ? (
          <div className="col-lg-3 col-12">
            <InputField1
              label="ساعت"
              onChange={(e) => setForm({ ...form, leave: e.target.value })}
            />
          </div>
        ) : (
          <div className="col-lg-3 col-12">
            <InputField1 label="مقدار مرخصی" readonly value="9" />
          </div>
        )}
        <div className="col-12 d-flex mt-4">
          <Button
            bgColor="#009ef7"
            small="fit-content"
            color="#fff"
            onclick={() => handleSetRollCall(form)}
          >
            ثبت
          </Button>
        </div>
      </div>
      <div className="RollCallTable">
        <RollCallTable />
      </div>
    </>
  );
};

export default RollCallAdmin;
